import { Color } from '../../../enums/color'
import { Theme } from '../../../types/theme'
import { ColorVariant } from '../types/colorVariant'

export const getTextToColor = (theme: Theme): Record<ColorVariant, Color> => ({
  primary: theme.ds.colors.base.textPrimary,
  secondary: theme.ds.colors.base.textSecondary,
  danger: Color.Red700,
  success: Color.Green700,
  discreet: Color.Grey500,
  disable: Color.Grey400,
  label: Color.Grey950,
  placeholder: Color.Grey500,
  inverted: Color.Grey50,
})
